













import { Component } from 'vue-property-decorator';

import FittedUsersList from "@share/common/users-list/FittedUsersList.vue";
import TimeCardFooterBase from '@share/common/cards/time-card/components/footer/TimeCardFooterBase.vue';

@Component({
    components: { FittedUsersList }
})
export default class SessionCardFooter extends TimeCardFooterBase {}

